import { enqueueSnackbar } from "notistack";
import { useApiClient } from "../../../api";
import { loadStripe } from "@stripe/stripe-js";
import { Button } from "@mui/material";
import React from "react";
import GeneralLoading from "../../../shared-components/Loading";
let stripePromise;

const getStripe = (key) => {
  if (!stripePromise) {
    stripePromise = loadStripe(key);
  }
  return stripePromise;
};
export const StripeSubscriptionManagement = ({
  redirecting,
  setRedirecting,
  label,
  buttonProps = {},
}) => {
  const ApiClient = useApiClient();

  const handleOpenBillingPortal = async () => {
    try {
      setRedirecting(true);
      const stripeKey = await ApiClient.subscriptions
        .getPaymentInfo()
        .then((res) => res.publicKey);
      const billingPortalLink =
        await ApiClient.subscriptions.getCustomerBillingPortalLink();

      if (billingPortalLink.success) {
        const stripe = await getStripe(stripeKey);
        if (stripe) {
          window.location.href = billingPortalLink.sessionUrl;
        }
      } else {
        enqueueSnackbar(billingPortalLink.message, {
          variant: "error",
          autoHideDuration: 3000,
        });
        setRedirecting(false);
      }
    } catch (err) {
      console.error("Failed to generate payment update link", err);
      enqueueSnackbar("Problem generating payment update link", {
        variant: "error",
        autoHideDuration: 3000,
      });
      setRedirecting(false);
    }
  };

  if (redirecting) {
    return <GeneralLoading direction={"row"} size={30} />;
  }

  return (
    <Button
      variant="contained"
      onClick={handleOpenBillingPortal}
      {...buttonProps}
    >
      {label}
    </Button>
  );
};
